import { ApiService } from './../api.service';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { tap, map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';


const routes = {
  listCategoryHeader: '/cms/cate-head',
  listFooterCategory: '/cms/cate-foot',
  viewLogo: '/cms/logo-image',
  companyInfor: '/cms/infor-foot',
  businessBenefit: '/cms/business-benefit',
  ourCustomer: '/cms/our-customer',
  customerReview: '/cms/customer-review',
  banner: '/cms/banner',
  loadPopup: '/cms/popup',
  
};

@Injectable({
  providedIn: 'root'
})
export class CmsService {

  constructor(private apiService: ApiService, private httpClient: HttpClient) { }

  listCategoryHeader() {
    return this.apiService.get(routes.listCategoryHeader)
      .pipe(map(res => {
        return res;
      }));
  }

  viewLogoImage() {
    return this.apiService.get(routes.viewLogo)
      .pipe(map(res => {
        return res;
      }));
  }

  listFooterCategory() {
    return this.apiService.get(routes.listFooterCategory)
      .pipe(map(res => {
        return res;
      }));
  }

  companyInfor() {
    return this.apiService.get(routes.companyInfor)
      .pipe(map(res => {
        return res;
      }));
  }

  businessBenefit() {
    return this.apiService.get(routes.businessBenefit)
      .pipe(map(res => {
        return res;
      }));
  }

  ourCustomer() {
    return this.apiService.get(routes.ourCustomer)
      .pipe(map(res => {
        return res;
      }));
  }

  customerReview() {
    return this.apiService.get(routes.customerReview)
      .pipe(map(res => {
        return res;
      }));
  }

  banner() {
    return this.apiService.get(routes.banner)
      .pipe(map(res => {
        return res;
      }));
  }

  
  loadPopup() {
    return this.apiService.get(routes.loadPopup)
      .pipe(map(res => {
        return res;
      }));
  }

}
